import React, {useEffect, useRef} from 'react';
import styles from './unsubPopup.module.css';

const UnsubPopup = ({isShown, messageText}) => {
  const unsubMessageClose = useRef(null);
  const messageUnsubText = useRef(null);
  const message = useRef(null);


  useEffect(() => {
    if (message.current && isShown) {
      message.current.style.display = 'flex';
      messageUnsubText.current.textContent = messageText;
    } else if (message.current) {
      message.current.removeAttribute('style');
      // message.current.style.display = 'none';
    }
  }, []);


  const handleVisibilityMessage = () => {
    // message.current.style.display = 'none';
    if (message.current) {
      message.current.removeAttribute('style');
    }
    window.location.href = 'https://www.google.com';
  };


  return (
    <div ref={message}
         className={styles.message}>
      <div className={styles.messageContent}>
        <button ref={unsubMessageClose}
                className={styles.formClose}
                onClick={handleVisibilityMessage}
                type="button">
          close
        </button>
        <p ref={messageUnsubText}
           className={styles.messageText}>
          Hello
        </p>
      </div>
    </div>
  )
}

export default UnsubPopup;